module.exports = __webpack_public_path__ + "static/media/3_MACDONALDS.d46e88be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/realisations/projet_mcdonalds/3_MACDONALDS.jpg
// module id = 1164
// module chunks = 37